import * as React from 'react';
import InputTypeQuestionComponent from './QuestionTypes/InputTypeQuestionComponent';
import NumericTypeQuestionComponent from './QuestionTypes/NumericTypeQuestionComponent';
import DatepickerTypeQuestionComponent from './QuestionTypes/DatepickerTypeQuestionComponent';
import RadioTypeQuestionComponent from './QuestionTypes/RadioTypeQuestionComponent';
import CheckboxTypeQuestionComponent from './QuestionTypes/CheckboxTypeQuestionComponent';
import DropdownTypeQuestionComponent from './QuestionTypes/DropdownTypeQuestionComponent';
import { Grid, Typography, Link, IconButton, Card, CardContent, FormControl, InputLabel, Input, Button } from '@material-ui/core';
import { addQuestionComment, updateAdminLevelQuestionDataValue } from 'src/effects/utils/preview';
import HelpIcon from '@material-ui/icons/Help';
import WarningIcon from '@material-ui/icons/Warning';
import * as moment from 'moment';
import CommentComponent from './CommentComponent';
import { addComment, getlastyearresponseCall } from 'src/effects/api/api.module';
import { SurveyStatusEnum } from 'src/constants/Enum/SurveyStatusEnum';
import ReactHtmlParser from 'react-html-parser';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import RamIntegrationComponent from './RamIntegrationComponent';
import { getRamIntegrationDataCall } from 'src/effects/api/api.module';
import { QuestionType } from '../../constants/Enum/ModuleEnum';
import AdminLevelTypeQuestionComponent from './QuestionTypes/AdminLevelTypeQuestionComponent';
import { getLocalStorageValue, setLocalStorageValue } from 'src/effects/utils/local-storage';
import { DATACOLLECTOR_COUNTRY_MODULE_SURVEY_KEY, DATACOLLECTOR_IS_OFFLINE_ACTIVE_KEY } from 'src/constants/constants';
import { UserType, UserTypeName } from 'src/constants/Enum/UserType';

export default class QuestionComponent extends React.Component<any, any> {
    state = {
        validationMessages: [],
        collapsed: true,
        showCommentsDialog: false,
        addCommentDivVisible: false,
        addCommentDescription: '',
        showRamIntegrationDialog: false,
        ramIntegrationData: [],
        questionAdminLevelResponse: this.props.question
    };

    constructor(props: any) {
        super(props);

        this.updateQuestion = this.updateQuestion.bind(this);
        this.toggleExpand = this.toggleExpand.bind(this);


        this.handleShowAllComments = this.handleShowAllComments.bind(this);
        this.handleShowAllCommentsClose = this.handleShowAllCommentsClose.bind(this);
        this.toggleAddCommentDiv = this.toggleAddCommentDiv.bind(this);
        this.handleCommentDescriptionChange = this.handleCommentDescriptionChange.bind(this);
        this.addQuestionComment = this.addQuestionComment.bind(this);
        this.handleRamIntegrationClose = this.handleRamIntegrationClose.bind(this);
    }


    componentDidMount() {
        this.setState({
            ['showDataBox_' + this.props.pageNumber + '_' + this.props.clusterIndex + '_' + this.props.questionId]: false,
            ['showLastYearData_' + this.props.pageNumber + '_' + this.props.clusterIndex + '_' + this.props.questionId]: {},
            questionAdminLevelResponse: this.props.question.input_type === QuestionType.AdminLevel ? this.props.question : {}
        });

    }

    componentWillReceiveProps(newProps: any) {
         if (newProps.questionId !== this.props.questionId) {
            this.setState({
                showDataBox: false,
                showLastYearData: {},
                questionAdminLevelResponse: newProps.question.input_type === QuestionType.AdminLevel ? newProps.question : {},
                collapsed: newProps.question.tooltip && newProps.question.tooltip.en && newProps.question.tooltip.en.length > 100 ? true : false
            });
        }
         this.validateQuestionConditions(newProps);
    }

    getRoleName(roleId: any) {
        let rolename = '';
        switch (roleId) {
            case UserType.HQAdmin: rolename = UserTypeName.HQAdmin;
                break;
            case UserType.RegionalAdmin: rolename = UserTypeName.RegionalAdmin;
                break;
            case UserType.DataCollector: rolename = UserTypeName.DataCollector;
                break;
            case UserType.DataManager: rolename = UserTypeName.DataManager;
                break;
            case UserType.DataUser: rolename = UserTypeName.DataUser;
                break;
            case UserType.DataManagerSupply: rolename = UserTypeName.DataManagerSupply;
                break;
            case UserType.DataManagerRegional: rolename = UserTypeName.DataManagerRegional;
                break;
            case UserType.DataManagerSupplyRegional: rolename = UserTypeName.DataManagerSupplyRegional;
                break;
        }
        return rolename;
    }

    addQuestionComment() {
        const loggedInUser = getLocalStorageValue('user');
        const rolename = this.getRoleName(loggedInUser.roleId);

        if (this.props.isResponsePage) {
            const data = {
                country_module_survey_mapping_id: this.props.countryModuleSurveyMappingId,
                question_id: this.props.question.question_id,
                comment_text: this.state.addCommentDescription,
                question_title: this.props.question.title ? this.props.question.title.en : '',
                page_number: this.props.pageNumber,
                commented_by_name: loggedInUser.firstName,
                commented_by_email: loggedInUser.email,
                commented_by_role: rolename,
            };
            const pages = this.props.pages;
            const page: any = pages[this.props.pageNumber - 1];
            const clusters = page.page.question_clusters;
            const cluster = clusters[this.props.clusterIndex];
            const question = cluster.questions[this.props.questionIndex];
            const isOfflineMode = getLocalStorageValue(`UserId_${loggedInUser.id}_${DATACOLLECTOR_IS_OFFLINE_ACTIVE_KEY}`);
            const userId = loggedInUser.id;

            // Updating comment in localstorage for offline mode
            if (isOfflineMode === true) {
                const moduleResponse = getLocalStorageValue(`UserId_${userId}_${DATACOLLECTOR_COUNTRY_MODULE_SURVEY_KEY}_${this.props.countryModuleSurveyMappingId}`);
                if (moduleResponse && question.question_comments) {
                    question.question_comments.splice(0, 0, data);
                    moduleResponse.data.payload.module_pages = pages;
                    question.is_response_offline_filled = true;
                    setLocalStorageValue(`UserId_${userId}_${DATACOLLECTOR_COUNTRY_MODULE_SURVEY_KEY}_${this.props.countryModuleSurveyMappingId}`, JSON.stringify(moduleResponse));
                    this.setState({ addCommentDescription: '', addCommentDivVisible: false })
                }
            }
            else {
                addComment(data).then((response) => {
                    if (response.data.success && response.data.payload) {
                        const comment = {
                            comment_text: response.data.payload.comment_text,
                            commented_by_name: response.data.payload.commented_by_name,
                            commented_by_email: response.data.payload.commented_by_email,
                            commented_by_role: response.data.payload.commented_by_role,
                            commented_date: response.data.payload.commented_date,

                        };

                        this.setState({ addCommentDescription: '', addCommentDivVisible: false })
                        addQuestionComment(this.props, comment);
                    }
                });
            }
        }
    }

    handleCommentDescriptionChange(event: any) {
        this.setState({ addCommentDescription: event.target.value });
    }

    toggleAddCommentDiv(addCommentDivVisible: any) {
        this.setState({ addCommentDivVisible, addCommentDescription: '' });
    }

    handleShowAllComments() {
        this.setState({ showCommentsDialog: true });
    }

    handleShowAllCommentsClose(value: any) {
        this.setState({ showCommentsDialog: !value });
    }

    toggleExpand(collapsed: any, event: any) {
        this.setState({ collapsed });
    }

    handleShowDataBox(showDataBox: any, question: any, countryModuleSurveyMappingId: any, event: any) {
        const questionId = question.question_id
        this.props.loaderVisibility(true);
        getlastyearresponseCall({ questionId, countryModuleSurveyMappingId }).then((res: any) => {
            let showLastYearData = 'No data available';
            if (res.data && res.data.success) {
                showLastYearData = res.data.payload;
            }

            this.setState({
                ['showDataBox_' + this.props.pageNumber + '_' + this.props.clusterIndex + '_' + this.props.questionId]: showDataBox,
                ['showLastYearData_' + this.props.pageNumber + '_' + this.props.clusterIndex + '_' + this.props.questionId]: showLastYearData
            });

            this.props.loaderVisibility(false);
        })
    }

    handleRamIntegration(ramQuestionIndicatorCode: any, ctryModuleSurveyMappingId: any, event: any) {
        this.props.loaderVisibility(true);
        const data = {
            ramIntegrationQuestionIndicatorCode: ramQuestionIndicatorCode,
            countryModuleSurveyMappingId: ctryModuleSurveyMappingId
        };

        getRamIntegrationDataCall(data).then((res) => {
            if (res.data.success) {
                this.setState({ ramIntegrationData: res.data.payload });
                this.setState({ showRamIntegrationDialog: true });
            }
            this.props.loaderVisibility(false);
        })
            .catch((err) => {
                this.props.loaderVisibility(false);
            });
    }

    handleRamIntegrationClose(value: any) {
        this.setState({ showRamIntegrationDialog: !value });
    }

    updateQuestion(updateQuestionData: any) {
        this.props.updateQuestion(updateQuestionData);
    }

    renderQuestionByQuestionType() {
        const { isResponsePage, surveyType } = this.props;

        switch (this.props.question.input_type) {
            case 1:
                return <InputTypeQuestionComponent
                    isResponsePage={isResponsePage}
                    surveyStatus={this.props.surveyStatus}
                    surveyType={surveyType}
                    moduleId={this.props.moduleId}
                    validationMessages={this.state.validationMessages}
                    pages={this.props.pages} pageNumber={this.props.pageNumber}
                    updateQuestion={this.updateQuestion}
                    clusterIndex={this.props.clusterIndex}
                    questionIndex={this.props.questionIndex}
                    questionId={this.props.questionId}
                    question={this.props.question} />
            case 2:
                return <NumericTypeQuestionComponent
                    isResponsePage={isResponsePage}
                    surveyStatus={this.props.surveyStatus}
                    surveyType={surveyType}
                    moduleId={this.props.moduleId}
                    pagePreview={this.props.pagePreview}
                    pages={this.props.pages}
                    pageNumber={this.props.pageNumber}
                    updateQuestion={this.updateQuestion}
                    clusterIndex={this.props.clusterIndex}
                    questionIndex={this.props.questionIndex}
                    questionId={this.props.questionId}
                    question={this.props.question} />
            case 3:
                return <DatepickerTypeQuestionComponent isResponsePage={isResponsePage} surveyStatus={this.props.surveyStatus} surveyType={surveyType} pages={this.props.pages} pageNumber={this.props.pageNumber} updateQuestion={this.updateQuestion} clusterIndex={this.props.clusterIndex} questionIndex={this.props.questionIndex} questionId={this.props.questionId} question={this.props.question} />
            case 4:
                return <DropdownTypeQuestionComponent isResponsePage={isResponsePage} surveyStatus={this.props.surveyStatus} surveyType={surveyType} moduleId={this.props.moduleId} pages={this.props.pages} pageNumber={this.props.pageNumber} updateQuestion={this.updateQuestion} clusterIndex={this.props.clusterIndex} questionIndex={this.props.questionIndex} questionId={this.props.questionId} question={this.props.question} />
            case 5:
                return <RadioTypeQuestionComponent isResponsePage={isResponsePage} surveyStatus={this.props.surveyStatus} surveyType={surveyType} pages={this.props.pages} pageNumber={this.props.pageNumber} updateQuestion={this.updateQuestion} clusterIndex={this.props.clusterIndex} questionIndex={this.props.questionIndex} questionId={this.props.questionId} question={this.props.question} />
            case 6:
                return <CheckboxTypeQuestionComponent isResponsePage={isResponsePage} surveyStatus={this.props.surveyStatus} surveyType={surveyType} pages={this.props.pages} pageNumber={this.props.pageNumber} updateQuestion={this.updateQuestion} clusterIndex={this.props.clusterIndex} questionIndex={this.props.questionIndex} questionId={this.props.questionId} question={this.props.question} />
            case 7:

                if (Object.keys(this.state.questionAdminLevelResponse).length > 0) {
                    return <AdminLevelTypeQuestionComponent
                        questionAdminLevelResponse={this.state.questionAdminLevelResponse}
                        isAutoCalculate={this.props.question.isAdminLevelAutoCalculate ? true : false}
                        surveyStatus={this.props.surveyStatus}
                        question={this.props.question}
                        pages={this.props.pages}
                        clusterIndex={this.props.clusterIndex}
                        questionIndex={this.props.questionIndex}
                        pageNumber={this.props.pageNumber}
                        updateQuestion={this.updateQuestion}
                        onAdminLevelAnswerChange={(event: any, index: number, classTypeIndex: number) => this.handleOnAdminLevelAnswerChange(event, index, classTypeIndex)}
                        onAnswerBlur={(event: any, index: number) => this.handleAnswerBlur(event)}
                        onUncheckedChange={(event: any, index: number, classTypeIndex: number) => this.handleOnAdminLevelAnswerChange(event, index, classTypeIndex)}
                        onAdminLevelTotalAnswerChange={(event: any, index: number, classTypeIndex: number) => this.handleOnAdminLevelTotalAnswerChange(event, index, classTypeIndex)}
                    />
                }
            default:
                return;
        }
    }

    getQuestionByQuestionId(questionId: any) {
        const questionMetadata = {
            clusterIndex: 0,
            questionIndex: 0,
            question: undefined,
            questionId: 0
        }

        for (const page of this.props.pages) {
            for (let clusterIndex: any = 0; clusterIndex < page.page.question_clusters.length; clusterIndex++) {
                for (let questionIndex: any = 0; questionIndex < page.page.question_clusters[clusterIndex].questions.length; questionIndex++) {
                    const questionData = page.page.question_clusters[clusterIndex].questions[questionIndex];
                    if (questionData && questionData.question_id === questionId) {
                        questionMetadata.clusterIndex = clusterIndex;
                        questionMetadata.questionIndex = questionIndex;
                        questionMetadata.questionId = questionId;
                        questionMetadata.question = questionData;
                        return questionMetadata;
                    }
                }
            }
        }

        return questionMetadata;
    }

    getQuestionResponses(question: any) {
        const setOneResponse = question.question_responses[0].value;
        let setTwoResponse;
        let setThreeResponse;

        if (question.class_type === 2) {
            setTwoResponse = question.question_responses[1].value;
        }
        if (question.class_type === 3) {
            setTwoResponse = question.question_responses[1].value;
            setThreeResponse = question.question_responses[2].value;
        }

        const response = {
            setOneResponse,
            setTwoResponse,
            setThreeResponse
        };

        return response;
    }

    validateQuestionConditions(newProps: any) {
        const validationMessages: any = [];
        const question = newProps.question;
        const response = this.getQuestionResponses(question);

        for (const validation of newProps.question.validations) {
            const validationMessage: any = this.validationConditionCheck(validation, newProps, question, response);
            if (validationMessage) {
                validationMessages.push(validationMessage)
            }
        }

        if (newProps.question.input_type === 2 && newProps.question.limit && newProps.question.min_value && newProps.question.max_value) {
            const validationMessage = this.validateForLimitCheck(question, response);
            if (validationMessage) {
                validationMessages.push(validationMessage);
            }
        }

        this.setState({ validationMessages });
    }

    validationConditionCheck(validationCondition: any, newProps: any, question: any, response: any) {
        let validationMessage = '';

        if (question && question.question_id) {
            switch (validationCondition.operator) {
                case "=":
                    validationMessage = this.validateForEqualCheck(question, validationCondition, response);
                    break;

                case "!=":
                    validationMessage = this.validateForNotEqualCheck(question, validationCondition, response);
                    break;

                case ">":
                    validationMessage = this.validateForGreaterThanCheck(question, validationCondition, response);
                    break;

                case "<":
                    validationMessage = this.validateForLessThanCheck(question, validationCondition, response);
                    break;

                case ">=":
                    validationMessage = this.validateForGreaterThanEqualCheck(question, validationCondition, response);
                    break;

                case "<=":
                    validationMessage = this.validateForLessThanEqualCheck(question, validationCondition, response);
                    break;

                default:
                    validationMessage = '';
                    break;
            }
        }

        return validationMessage;
    }

    validateForLimitCheck(question: any, response: any) {
        const minVal = question.min_value;
        const maxVal = question.max_value;

        switch (question.class_type) {
            case 1: {
                if (!(parseInt(response.setOneResponse, 10) >= minVal && parseInt(response.setOneResponse, 10) <= maxVal)) {
                    return `Response must be between ${minVal} - ${maxVal}`;
                }
            }
                break;
            case 2: {
                if (!(parseInt(response.setOneResponse, 10) >= minVal && parseInt(response.setOneResponse, 10) <= maxVal)
                    || !(parseInt(response.setTwoResponse, 10) >= minVal && parseInt(response.setTwoResponse, 10) <= maxVal)) {
                    return `Response must be between ${minVal} - ${maxVal}`;
                }
            }
                break;
            case 3: {
                if (!(parseInt(response.setOneResponse, 10) >= minVal && parseInt(response.setOneResponse, 10) <= maxVal)
                    || !(parseInt(response.setTwoResponse, 10) >= minVal && parseInt(response.setTwoResponse, 10) <= maxVal)
                    || !(parseInt(response.setThreeResponse, 10) >= minVal && parseInt(response.setThreeResponse, 10) <= maxVal)) {
                    return `Response must be between ${minVal} - ${maxVal}`;
                }
                break;
            }
        }

        return '';
    }

    validateForEqualCheck(question: any, validationCondition: any, response: any) {
        const validationValue = validationCondition.value;
        switch (question.input_type) {
            case 1:
            case 4:
            case 5:
                {
                    switch (question.class_type) {
                        case 1: {
                            return response.setOneResponse === validationValue && response.setOneResponse ? validationCondition.message.en : '';
                        }
                            break;
                        case 2: {
                            return (response.setOneResponse === validationValue || response.setTwoResponse === validationValue) && response.setOneResponse && response.setTwoResponse
                                ? validationCondition.message.en : '';
                        }
                            break;
                        case 3: {
                            return (response.setOneResponse === validationValue || response.setTwoResponse === validationValue || response.setThreeResponse === validationValue) && response.setOneResponse && response.setTwoResponse && response.setThreeResponse
                                ? validationCondition.message.en : '';
                        }
                            break;
                    }
                }
                break;
            case 2:
                {
                    const validationNumber = parseInt(validationValue, 10);

                    switch (question.class_type) {
                        case 1: {
                            return parseInt(response.setOneResponse, 10) === validationNumber ? validationCondition.message.en : '';
                        }
                            break;
                        case 2: {
                            return parseInt(response.setOneResponse, 10) === validationNumber || parseInt(response.setTwoResponse, 10) === validationNumber
                                ? validationCondition.message.en : '';
                        }
                            break;
                        case 3: {
                            return parseInt(response.setOneResponse, 10) === validationNumber || parseInt(response.setTwoResponse, 10) === validationNumber || parseInt(response.setThreeResponse, 10) === validationNumber
                                ? validationCondition.message.en : '';
                        }
                            break;
                    }
                }
                break;
            case 3:
                {
                    const validationDate = moment(validationValue, "DD-MM-YYYY");
                    const setOneDate = moment(response.setOneResponse);
                    const setTwoDate = moment(response.setTwoResponse);
                    const setThreeDate = moment(response.setThreeResponse);

                    switch (question.class_type) {
                        case 1: {
                            return !response.setOneResponse || setOneDate.isSame(validationDate) ? validationCondition.message.en : '';
                        }
                            break;
                        case 2: {
                            return !response.setOneResponse || !response.setTwoResponse || setOneDate.isSame(validationDate) || setTwoDate.isSame(validationDate)
                                ? validationCondition.message.en : '';
                        }
                            break;
                        case 3: {
                            return !response.setOneResponse || !response.setTwoResponse || !response.setThreeResponse || setOneDate.isSame(validationDate) || setTwoDate.isSame(validationDate) || setThreeDate.isSame(validationDate)
                                ? validationCondition.message.en : '';
                        }
                            break;
                    }
                }
                break;
        }

        return '';
    }

    validateForNotEqualCheck(question: any, validationCondition: any, response: any) {
        const validationValue = validationCondition.value;
        switch (question.input_type) {
            case 1:
            case 4:
            case 5:
                {
                    switch (question.class_type) {
                        case 1: {
                            return response.setOneResponse !== validationValue && response.setOneResponse ? validationCondition.message.en : '';
                        }
                            break;
                        case 2: {
                            return (response.setOneResponse !== validationValue || response.setTwoResponse !== validationValue) && response.setOneResponse && response.setTwoResponse
                                ? validationCondition.message.en : '';
                        }
                            break;
                        case 3: {
                            return (response.setOneResponse !== validationValue || response.setTwoResponse !== validationValue || response.setThreeResponse !== validationValue) && response.setOneResponse && response.setTwoResponse && response.setThreeResponse
                                ? validationCondition.message.en : '';
                        }
                            break;
                    }
                }
                break;
            case 2:
                {
                    const validationNumber = parseInt(validationValue, 10);

                    switch (question.class_type) {
                        case 1: {
                            return parseInt(response.setOneResponse, 10) !== validationNumber ? validationCondition.message.en : '';
                        }
                            break;
                        case 2: {
                            return parseInt(response.setOneResponse, 10) !== validationNumber || parseInt(response.setTwoResponse, 10) !== validationNumber
                                ? validationCondition.message.en : '';
                        }
                            break;
                        case 3: {
                            return parseInt(response.setOneResponse, 10) !== validationNumber || parseInt(response.setTwoResponse, 10) !== validationNumber || parseInt(response.setThreeResponse, 10) !== validationNumber
                                ? validationCondition.message.en : '';
                        }
                            break;
                    }
                }
            case 3:
                {
                    const validationDate = moment(validationValue, "DD-MM-YYYY");
                    const setOneDate = moment(response.setOneResponse);
                    const setTwoDate = moment(response.setTwoResponse);
                    const setThreeDate = moment(response.setThreeResponse);

                    switch (question.class_type) {
                        case 1: {
                            return setOneDate.date !== validationDate.date ? validationCondition.message.en : '';
                        }
                            break;
                        case 2: {
                            return setOneDate.date !== validationDate.date || setTwoDate.date !== validationDate.date
                                ? validationCondition.message.en : '';
                        }
                            break;
                        case 3: {
                            return setOneDate.date !== validationDate.date || setTwoDate.date !== validationDate.date || setThreeDate.date !== validationDate.date
                                ? validationCondition.message.en : '';
                        }
                            break;
                    }
                }
                break;

        }

        return '';
    }

    validateForGreaterThanCheck(question: any, validationCondition: any, response: any) {
        const validationValue = validationCondition.value;
        switch (question.input_type) {
            case 2:
                {
                    switch (question.class_type) {
                        case 1: {
                            if (parseInt(response.setOneResponse, 10) > parseInt(validationValue, 10)) {
                                return validationCondition.message.en;
                            }
                        }
                            break;
                        case 2: {
                            if (parseInt(response.setOneResponse, 10) > parseInt(validationValue, 10)
                                || parseInt(response.setTwoResponse, 10) > parseInt(validationValue, 10)) {
                                return validationCondition.message.en;
                            }
                        }
                            break;
                        case 3: {
                            if (parseInt(response.setOneResponse, 10) > parseInt(validationValue, 10)
                                || parseInt(response.setTwoResponse, 10) > parseInt(validationValue, 10)
                                || parseInt(response.setThreeResponse, 10) > parseInt(validationValue, 10)) {
                                return validationCondition.message.en;
                            }
                        }
                            break;
                    }
                }
                break;
            case 3:
                {
                    const validationDate = moment(validationValue, "DD-MM-YYYY");
                    const setOneDate = moment(response.setOneResponse);
                    const setTwoDate = moment(response.setTwoResponse);
                    const setThreeDate = moment(response.setThreeResponse);

                    switch (question.class_type) {
                        case 1: {
                            return !response.setOneResponse || setOneDate.isAfter(validationDate) ? validationCondition.message.en : '';
                        }
                            break;
                        case 2: {
                            return !response.setOneResponse || !response.setTwoResponse || setOneDate.isAfter(validationDate) || setTwoDate.isAfter(validationDate)
                                ? validationCondition.message.en : '';
                        }
                            break;
                        case 3: {
                            return !response.setOneResponse || !response.setTwoResponse || !response.setThreeResponse || setOneDate.isAfter(validationDate) || setTwoDate.isAfter(validationDate) || setThreeDate.isAfter(validationDate)
                                ? validationCondition.message.en : '';
                        }
                            break;
                    }
                }
                break;
        }

        return '';
    }

    validateForLessThanCheck(question: any, validationCondition: any, response: any) {
        const validationValue = validationCondition.value;
        switch (question.input_type) {
            case 2:
                {
                    switch (question.class_type) {
                        case 1: {
                            if (parseInt(response.setOneResponse, 10) < parseInt(validationValue, 10)) {
                                return validationCondition.message.en;
                            }
                        }
                            break;
                        case 2: {
                            if (parseInt(response.setOneResponse, 10) < parseInt(validationValue, 10)
                                || parseInt(response.setTwoResponse, 10) < parseInt(validationValue, 10)) {
                                return validationCondition.message.en;
                            }
                        }
                            break;
                        case 3: {
                            if (parseInt(response.setOneResponse, 10) < parseInt(validationValue, 10)
                                || parseInt(response.setTwoResponse, 10) < parseInt(validationValue, 10)
                                || parseInt(response.setThreeResponse, 10) < parseInt(validationValue, 10)) {
                                return validationCondition.message.en;
                            }
                        }
                            break;
                    }
                }
                break;
            case 3:
                {
                    const validationDate = moment(validationValue, "DD-MM-YYYY");
                    const setOneDate = moment(response.setOneResponse);
                    const setTwoDate = moment(response.setTwoResponse);
                    const setThreeDate = moment(response.setThreeResponse);

                    switch (question.class_type) {
                        case 1: {
                            return !response.setOneResponse || setOneDate.isBefore(validationDate) ? validationCondition.message.en : '';
                        }
                            break;
                        case 2: {
                            return !response.setOneResponse || !response.setTwoResponse || setOneDate.isBefore(validationDate) || setTwoDate.isBefore(validationDate)
                                ? validationCondition.message.en : '';
                        }
                            break;
                        case 3: {
                            return !response.setOneResponse || !response.setTwoResponse || !response.setThreeResponse || setOneDate.isBefore(validationDate) || setTwoDate.isBefore(validationDate) || setThreeDate.isBefore(validationDate)
                                ? validationCondition.message.en : '';
                        }
                            break;
                    }
                }
                break;
        }

        return '';
    }

    validateForGreaterThanEqualCheck(question: any, validationCondition: any, response: any) {
        const validationValue = validationCondition.value;
        switch (question.input_type) {
            case 2:
                {
                    switch (question.class_type) {
                        case 1: {
                            if (parseInt(response.setOneResponse, 10) >= parseInt(validationValue, 10)) {
                                return validationCondition.message.en;
                            }
                        }
                            break;
                        case 2: {
                            if (parseInt(response.setOneResponse, 10) >= parseInt(validationValue, 10)
                                || parseInt(response.setTwoResponse, 10) >= parseInt(validationValue, 10)) {
                                return validationCondition.message.en;
                            }
                        }
                            break;
                        case 3: {
                            if (parseInt(response.setOneResponse, 10) >= parseInt(validationValue, 10)
                                || parseInt(response.setTwoResponse, 10) >= parseInt(validationValue, 10)
                                || parseInt(response.setThreeResponse, 10) >= parseInt(validationValue, 10)) {
                                return validationCondition.message.en;
                            }
                        }
                            break;
                    }
                }
                break;
            case 3:
                {
                    const validationDate = moment(validationValue, "DD-MM-YYYY");
                    const setOneDate = moment(response.setOneResponse);
                    const setTwoDate = moment(response.setTwoResponse);
                    const setThreeDate = moment(response.setThreeResponse);

                    switch (question.class_type) {
                        case 1: {
                            return !response.setOneResponse || setOneDate.isSameOrAfter(validationDate) ? validationCondition.message.en : '';
                        }
                            break;
                        case 2: {
                            return !response.setOneResponse || !response.setTwoResponse || setOneDate.isSameOrAfter(validationDate) || setTwoDate.isSameOrAfter(validationDate)
                                ? validationCondition.message.en : '';
                        }
                            break;
                        case 3: {
                            return !response.setOneResponse || !response.setTwoResponse || !response.setThreeResponse || setOneDate.isSameOrAfter(validationDate) || setTwoDate.isSameOrAfter(validationDate) || setThreeDate.isSameOrAfter(validationDate)
                                ? validationCondition.message.en : '';
                        }
                            break;
                    }
                }
                break;
        }

        return '';
    }

    validateForLessThanEqualCheck(question: any, validationCondition: any, response: any) {
        const validationValue = validationCondition.value;
        switch (question.input_type) {
            case 2:
                {
                    switch (question.class_type) {
                        case 1: {
                            if (parseInt(response.setOneResponse, 10) <= parseInt(validationValue, 10)) {
                                return validationCondition.message.en;
                            }
                        }
                            break;
                        case 2: {
                            if (parseInt(response.setOneResponse, 10) <= parseInt(validationValue, 10)
                                || parseInt(response.setTwoResponse, 10) <= parseInt(validationValue, 10)) {
                                return validationCondition.message.en;
                            }
                        }
                            break;
                        case 3: {
                            if (parseInt(response.setOneResponse, 10) <= parseInt(validationValue, 10)
                                || parseInt(response.setTwoResponse, 10) <= parseInt(validationValue, 10)
                                || parseInt(response.setThreeResponse, 10) <= parseInt(validationValue, 10)) {
                                return validationCondition.message.en;
                            }
                        }
                            break;
                    }
                }
                break;
            case 3:
                {
                    const validationDate = moment(validationValue, "DD-MM-YYYY");
                    const setOneDate = moment(response.setOneResponse);
                    const setTwoDate = moment(response.setTwoResponse);
                    const setThreeDate = moment(response.setThreeResponse);

                    switch (question.class_type) {
                        case 1: {
                            return !response.setOneResponse || setOneDate.isSameOrBefore(validationDate) ? validationCondition.message.en : '';
                        }
                        case 2: {
                            return !response.setOneResponse || !response.setTwoResponse || setOneDate.isSameOrBefore(validationDate) || setTwoDate.isSameOrBefore(validationDate)
                                ? validationCondition.message.en : '';
                        }
                        case 3: {
                            return !response.setOneResponse || !response.setTwoResponse || !response.setThreeResponse || setOneDate.isSameOrBefore(validationDate) || setTwoDate.isSameOrBefore(validationDate) || setThreeDate.isSameOrBefore(validationDate)
                                ? validationCondition.message.en : '';
                        }
                    }
                }
                break;
        }

        return '';
    }

    renderQuestionComments() {
        const elements: any = [];
        if (this.props.question && this.props.question.question_comments && this.props.question.question_comments.length > 0) {
            this.props.question.question_comments.forEach((comment: any) => {
                const localTime = moment.utc(comment.commented_date).toDate();
                const localTimeFormatted = moment(localTime).format('DD-MM-YYYY hh:mm:ss a');
                elements.push(
                    <Card className={comment.commented_by_role && (comment.commented_by_role === 'HQ Admin' || comment.commented_by_role === 'Regional Admin' || comment.commented_by_role === 'Data Manager') ? "commentsBoxRed" : "commentsBox"}>
                        <CardContent>
                            <div className="card card-default">
                                <div className="card-body">

                                    <div className="addCommentAction alignWrapper">
                                        <div className="alignLeft">
                                            <div className="comment-user">{comment ? `${comment.commented_by_name}(${comment.commented_by_role}) | ${comment.commented_by_email}` : ''}</div>
                                        </div>
                                    </div>

                                    <div className="comment-post">
                                        <span>
                                            {comment ? comment.comment_text : ''}
                                        </span>
                                    </div>
                                    <div className="text-right">
                                        <span className="comment-date"> {comment ? localTimeFormatted : ''}</span>
                                    </div>
                                </div>
                            </div>

                        </CardContent>
                    </Card>
                );
            });
        }

        return elements;
    }

    renderLastYearData(response: any) {
        const elements: any = [];
        if (!response || response.record_not_found) {
            elements.push(
                <div><b>No data available</b></div>
            );
        }
        else if (response && response.admin_level_responses && response.admin_level_responses.length > 0) {

            response.admin_level_responses.map((adminResponse: any, index: any) => {

                elements.push(
                    <Grid container={true}>
                        <Grid item={true} xs={5} className="queType">
                            <span>{adminResponse.key}</span>
                        </Grid>
                        <Grid item={true} xs={3} className="queNo">
                            <span>{adminResponse.value}</span>
                        </Grid>
                    </Grid>
                );


            })

        }
        else {
            switch (response.class_type) {
                case 1:
                    {
                        elements.push(
                            <div>{/*Set 1:*/}<b>{response.set_one_value}</b></div>
                        );
                    }
                    break;
                case 2:
                    {
                        elements.push(
                            <>
                                <div><b>{response.set_one_value}</b></div>
                                <div><b>{response.set_two_value}</b></div>
                            </>
                        );
                    }
                    break;
                case 3:
                    {
                        elements.push(
                            <>
                                <div><b>{response.set_one_value}</b></div>
                                <div><b>{response.set_two_value}</b></div>
                                <div><b>{response.set_three_value}</b></div>
                            </>
                        );
                    }
                    break;
            }
        }

        return elements;
    }

    // appending the array with the provided answers against associated question
    handleOnAdminLevelAnswerChange(event: any, index: number, classTypeIndex: number) {
        if (event === undefined || event.target === undefined) { return; }
        const name = event.target.name;
        const questionAdminLevelResponse = this.state.questionAdminLevelResponse;
        const totalIndex = questionAdminLevelResponse.question_admin_responses[classTypeIndex].findIndex((x: any) => x !== null ? x.adminLevel === 'Total' : null);

        if (name.indexOf('unavailable') === -1) {
            const value = event.target.value;
            questionAdminLevelResponse.question_admin_responses[classTypeIndex][index].value = value.trim();
            this.setState({ questionAdminLevelResponse }, () => {
                const adminLevelsExceptTotal = questionAdminLevelResponse.question_admin_responses[classTypeIndex].filter((x: any) => x !== null ?  x.adminLevel !== 'Total' && x.unavailable === false : null);
                let total = 0;
                adminLevelsExceptTotal.forEach((x: any) => {
                    total += x.value ? parseInt(x.value, 10) : 0;
                });
                if (totalIndex !== -1) {
                    questionAdminLevelResponse.question_admin_responses[classTypeIndex][totalIndex].value = total.toString();
                }
                this.setState({ questionAdminLevelResponse });
            })
        } else {
            const isUnavailable = event.target.checked;

            questionAdminLevelResponse.question_admin_responses[classTypeIndex][index].unavailable = isUnavailable;
            questionAdminLevelResponse.question_admin_responses[classTypeIndex][index].value = '0';

            const adminLevelsExceptTotal = questionAdminLevelResponse.question_admin_responses[classTypeIndex].filter((x: any) => x.adminLevel !== 'Total');
            let total = 0;
            adminLevelsExceptTotal.forEach((x: any) => {
                total += x.value ? parseInt(x.value, 10) : 0;
            });

            if (totalIndex !== -1) {
                questionAdminLevelResponse.question_admin_responses[classTypeIndex][totalIndex].value = total.toString();
            }

            this.setState({ questionAdminLevelResponse }, () => {
                if (!this.props.isReviewQuetion) {
                    updateAdminLevelQuestionDataValue(this.props, this.state.questionAdminLevelResponse.class_type, isUnavailable, false, null, true, [], this.state.questionAdminLevelResponse)

                }
            })
        }
    }

    handleOnAdminLevelTotalAnswerChange(event: any, index: number, classTypeIndex: number) {
        if (event === undefined || event.target === undefined) { return; }
        const name = event.target.name;
        const questionAdminLevelResponse = this.state.questionAdminLevelResponse;

        if (name.indexOf('unavailable') === -1) {
            const value = event.target.value;

            questionAdminLevelResponse.question_admin_responses[classTypeIndex][index].value = value.trim();
            this.setState({ questionAdminLevelResponse })
        } else {
            const isUnavailable = event.target.checked;

            questionAdminLevelResponse.question_admin_responses[classTypeIndex][index].unavailable = isUnavailable;
            questionAdminLevelResponse.question_admin_responses[classTypeIndex][index].value = '0';
            this.setState({ questionAdminLevelResponse }, () => {
                if (!this.props.isReviewQuetion) {
                    updateAdminLevelQuestionDataValue(this.props, this.state.questionAdminLevelResponse.class_type, isUnavailable, false, null, true, [], this.state.questionAdminLevelResponse)
                }
            })
        }
    }

    // calling api to update in BE
    handleAnswerBlur(event: any) {
        const value = event.target.value.trim();
        if (!this.props.isReviewQuetion) {
            updateAdminLevelQuestionDataValue(this.props, this.state.questionAdminLevelResponse.class_type, value, false, null, true, [], this.state.questionAdminLevelResponse)
        }
    }

    render() {
        const showDataBoxState = this.state['showDataBox_' + this.props.pageNumber + '_' + this.props.clusterIndex + '_' + this.props.questionId];
        const showLastYearDataState = this.state['showLastYearData_' + this.props.pageNumber + '_' + this.props.clusterIndex + '_' + this.props.questionId];
        const isDisplayComment = window.location.href.indexOf('preview') > -1 ? false : true;

        return (
            <div>
                {
                    this.props.question && this.props.question.is_visible &&
                    <div className="questionWrapper" id={this.props.pageNumber + '_' + this.props.clusterIndex + '_' + this.props.questionIndex}>
                        <Grid container={true} spacing={24}>
                            <Grid item={true} xs={1} className="queNo" >
                                <span>{this.props.question.question_number}</span>
                            </Grid>
                            <Grid item={true} xs={11} className="queType" >
                                <p className="question-title"><strong>{this.props.question.title.en}</strong></p>
                                <Grid container={true} spacing={24}>
                                    {
                                        this.renderQuestionByQuestionType()
                                    }
                                </Grid>

                                {
                                    // Existing code
                                    <div className="showDataBoxWrapper">
                                        {
                                            this.props.question && !this.props.isOfflineMode && this.props.isShowRecentData ?
                                                <Typography>
                                                    {/* Uncommented show recent data link as suggested by client */}
                                                    <Link href="javascript:void(0)"  onClick={this.props.isResponsePage ? this.handleShowDataBox.bind(this, true, this.props.question, this.props.countryModuleSurveyMappingId) : null} className="pageLink showDataLink">
                                                        Show recent data
                                                    </Link> 
                                                    {
                                                        showDataBoxState ?
                                                            <div className={this.props.question.input_type === QuestionType.AdminLevel ? "showAdminDataBox" : "showDataBox"}>
                                                                {
                                                                    showLastYearDataState && showLastYearDataState.record_not_found ?
                                                                        <div><b>No data available</b></div>
                                                                        :
                                                                        this.renderLastYearData(showLastYearDataState)
                                                                }
                                                            </div>
                                                            :
                                                            ''
                                                    }
                                                </Typography>
                                                :
                                                ''

                                        }
                                        {
                                            this.props.question && this.props.question.ram_question_indicator_code && !this.props.isOfflineMode ?

                                                <Typography>
                                                    <Link href="javascript:void(0)" onClick={this.handleRamIntegration.bind(this, this.props.question.ram_question_indicator_code, this.props.countryModuleSurveyMappingId)} className="pageLink showDataLink">
                                                        View RAM data
                                                    </Link>
                                                </Typography> : ''
                                        }
                                    </div>
                                }
                            </Grid>
                            <Grid item={true} xs={1} />
                            <Grid item={true} xs={11} className="queComments adminQuestionComment" >
                                {
                                    this.props.question.tooltip &&
                                        this.props.question.tooltip.en &&
                                        this.props.question.tooltip.en !== "<p><br></p>" ?
                                        <div className="commentsWrapper">

                                            <>
                                                <IconButton
                                                    aria-label="Show hint text"> <HelpIcon />
                                                </IconButton>
                                                {
                                                    this.state.collapsed
                                                        ?
                                                        <div className="queCommentsText">
                                                            {ReactHtmlParser(this.props.question.tooltip.en.substr(0, 100))}
                                                            <Typography>
                                                                <Link href="javascript:void(0)" onClick={this.toggleExpand.bind(this, false)} className="pageLink">[ Expand ]</Link>
                                                            </Typography>
                                                        </div>
                                                        :
                                                        <div className="queCommentsText">
                                                            {ReactHtmlParser(this.props.question.tooltip.en)}
                                                            <Typography>
                                                                <Link href="javascript:void(0)" onClick={this.toggleExpand.bind(this, true)} className="pageLink">[ Collapse ]</Link>
                                                            </Typography>
                                                        </div>
                                                }

                                            </>

                                        </div>
                                        :
                                        ''
                                }

                                {
                                    <div className="commentsBoxWrapper">

                                        <div className="commentsBadge alignWrapper">
                                            <div className="alignLeft">
                                                {
                                                    (!this.props.question || !this.props.question.question_comments || this.props.question.question_comments.length === 0) || !isDisplayComment ?
                                                        <b className="textCapital">No Comments Yet...</b>
                                                        :
                                                        <b className="textCapital">{`Comments (${this.props.question.question_comments_count})`}</b>
                                                }
                                            </div>
                                            <div className="grow" />
                                            <div className="alignRight">
                                                {
                                                    this.props.question && isDisplayComment && this.props.question.question_comments && this.props.question.question_comments.length > 0 ?
                                                        <Typography>
                                                            <Link href="javascript:void(0)" className="pageLink" onClick={this.handleShowAllComments} >
                                                                Show All Comments
                                                            </Link>
                                                        </Typography>
                                                        : ''
                                                }
                                            </div>

                                            {
                                                this.state.showCommentsDialog &&
                                                <CommentComponent
                                                    showCommentsDialog={this.state.showCommentsDialog}
                                                    onDialogClose={this.handleShowAllCommentsClose}
                                                    countryModuleSurveyMappingId={this.props.countryModuleSurveyMappingId}
                                                    questionId={this.props.question.id}
                                                />
                                            }

                                            {
                                                this.state.showRamIntegrationDialog &&
                                                <RamIntegrationComponent
                                                    showRamIntegrationDialog={this.state.showRamIntegrationDialog}
                                                    onDialogClose={this.handleRamIntegrationClose}
                                                    ramIntegrationData={this.state.ramIntegrationData}
                                                />
                                            }

                                        </div>

                                        {
                                            this.props.question && isDisplayComment && this.props.question.question_comments && this.props.question.question_comments.length > 0
                                                ?
                                                this.renderQuestionComments()
                                                :
                                                ''
                                        }

                                        {
                                            this.state.addCommentDivVisible && this.props.surveyStatus !== SurveyStatusEnum.Finished ?
                                                <div className="addComment">
                                                    <FormControl margin="normal" required={false} fullWidth={true} >
                                                        <InputLabel htmlFor="commentDescription">Comment Description</InputLabel>
                                                        <Input id="commentDescription" name="commentDescription"
                                                            multiline={true}
                                                            autoFocus={false}
                                                            value={this.state.addCommentDescription}
                                                            onChange={this.handleCommentDescriptionChange}
                                                        />
                                                    </FormControl>

                                                    <div className="addCommentAction alignWrapper">
                                                        <div className="alignLeft">
                                                            <Link href="javascript:void(0)" onClick={this.toggleAddCommentDiv.bind(this, false)} className="linkRed">
                                                                Cancel
                                                            </Link>
                                                        </div>
                                                        <div className="grow" />
                                                        <div className="alignRight">
                                                            <Button type="button" className="btn-blue-primary" onClick={this.addQuestionComment} variant="outlined" size="medium">
                                                                Add Comment <ChevronRightIcon className="ChevronRightIcon" />
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                ''
                                        }

                                        <div>
                                            {
                                                !this.state.addCommentDivVisible && this.props.surveyStatus !== SurveyStatusEnum.Finished ?
                                                    <Typography>
                                                        <Link href="javascript:void(0)" onClick={this.toggleAddCommentDiv.bind(this, true)} className="pageLink">
                                                            + Add Comment
                                                        </Link>
                                                    </Typography>
                                                    :
                                                    ''
                                            }
                                        </div>
                                    </div>
                                }
                            </Grid>

                            <Grid item={true} xs={12}  >
                                {
                                    this.state.validationMessages && this.state.validationMessages.length ?
                                        (<div>
                                            <div className="warningMessage">
                                                <span className="warningMessageIcon">
                                                    <WarningIcon />
                                                </span>
                                                {this.state.validationMessages[0]}
                                            </div>
                                        </div>
                                        ) : ''
                                }
                            </Grid>

                        </Grid>
                    </div>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/responses/QuestionComponent.tsx